import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { ReactComponent as ExitIcon } from '../../../image/BlackExit.svg';
import { ReactComponent as DownArrowIcon } from '../../../image/DownArrow.svg';
import { ReactComponent as MenuSvgIcon } from '../../../image/Menu.svg';
import { ReactComponent as CopyIcon } from '../../../image/Copy.svg';

export default function MemberShipInfoBox(props) {
  const {
    data,
    index,
    isClickedMemberShipEdit,
    onClickEditMemberShipButton,
    onClickDeletedMemberShip,
    onClickChangeIndex,
    onClickCopyMemberShip,
  } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: `mem-${data.id}` });
  const style = { transform: CSS.Transform.toString(transform), transition: isDragging ? 'none' : transition };

  const [isIconWrapper, setIsIconWrapper] = useState(false);
  const [isMenuHover, setIsMenuHover] = useState(false);

  const ExitRef = useRef();

  // 회원권 정보 클릭시 //
  function onClickEditMemberShip(e) {
    if (ExitRef.current && ExitRef.current.contains(e.target)) return;
    onClickEditMemberShipButton(data);
  }

  // 위로이동 버튼 클릭시 //
  function onClickMoveUp(e) {
    e.stopPropagation();
    if (onClickChangeIndex) onClickChangeIndex('UP', index);
  }

  // 아래로이동 버튼 클릭시 //
  function onClickMoveDown(e) {
    e.stopPropagation();
    if (onClickChangeIndex) onClickChangeIndex('DOWN', index);
  }

  return (
    <TopLevelWrapper
      ref={setNodeRef} style={style} {...attributes}
      $isHideAll={data.isHideAll}
      onClick={onClickEditMemberShip}>
      <TextWrapper>
        <ArrowWrapper
          isHover={isIconWrapper}
          onMouseEnter={() => setIsIconWrapper(true)}
          onMouseLeave={() => { setIsIconWrapper(false); setIsMenuHover(false); }}
          onTouchStart={(e) => { e.stopPropagation(); setIsIconWrapper(v => !v); }}
          onClick={(e) => e.stopPropagation()}>
          <ArrowImageWrapper onClick={onClickMoveUp} onTouchStart={(e) => e.stopPropagation()}>
            <StyledUpArrowSvg style={{ color: theme.line }} $dimmed={isIconWrapper} isMenuHover={isMenuHover} />
          </ArrowImageWrapper>
          <StyledMenuIconSvg
            {...listeners}
            $isDragging={isDragging}
            $isVisible={isIconWrapper}
            preserveAspectRatio="none"
            onMouseEnter={() => setIsMenuHover(true)}
            onMouseLeave={() => setIsMenuHover(false)} />
          <ArrowImageWrapper onClick={onClickMoveDown} onTouchStart={(e) => e.stopPropagation()}>
            <StyledDownArrowSvg style={{ color: theme.line }} $dimmed={isIconWrapper} isMenuHover={isMenuHover} />
          </ArrowImageWrapper>
        </ArrowWrapper>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={data.isHideAll ? theme.bottomText : theme.text} cursor='pointer' >{data.name}</Text>
      </TextWrapper>
      <StatusWrapper>
        { data.isHideAll && <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('system.private')}</Text> }
        <ImageWrapper>
          {
            data.autoPayment === 1 &&
            <SubscriptBox>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('settingMembership.subscription')}</Text>
            </SubscriptBox>
          }
          <ButtonWrapper ref={ExitRef}>
            <StyledCopyIcon onClick={(e) => { e.stopPropagation(); onClickCopyMemberShip(data); }} />
            <ExitIconWrapper onClick={(e) => { e.stopPropagation(); onClickDeletedMemberShip(data); }}>
              <ExitIcon />
            </ExitIconWrapper>
          </ButtonWrapper>
        </ImageWrapper>
      </StatusWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 10px 20px 10px 15px;

  box-sizing: border-box;
  width: 500.5px;
  height: 55px;

  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StatusWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin: 0 10px 0 0;

  width: 100%;

  gap: 15px;

  overflow: hidden;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: noWrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 20px;
`;

const SubscriptBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  border-radius: 5px;
  background-color: ${props => props.theme.primary};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;
`;

const ExitIconWrapper = styled.div`
  width: 20px;
  height: 20px;

  & svg {
    width: 20px;
    height: 20px;
  }

  & path {
    fill: ${props => props.theme.line};
    transition: fill 0.3s ease-in-out;
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
    &:hover path {
      fill: ${props => props.theme.primary};
    }
  }
`;

const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 42px;

  gap: 10px;
`;

const ArrowImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 6px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
    &:hover svg path {
      stroke: ${props => props.theme.primary};
    }
  }
`;

const StyledUpArrowSvg = styled(DownArrowIcon)`
  width: 20px;
  height: auto;

  transform: ${props => props.$dimmed ? 'rotate(180deg) translateY(-5px)' : 'rotate(180deg) translateY(-13px)'};

  opacity: ${props => props.isMenuHover ? 0.2 : 1};
  transition: color 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover path {
      stroke: ${props => props.theme.primary};
    }
  }
`;

const StyledDownArrowSvg = styled(DownArrowIcon)`
  width: 18px;
  height: auto;

  transform: ${props => props.$dimmed ? 'translateY(-5px)' : 'translateY(-13px)'};

  opacity: ${props => props.isMenuHover ? 0.2 : 1};
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

  & path {
    transition: stroke 0.3s ease-in-out;
  }

  @media (hover: hover) {
    &:hover path {
      stroke: ${props => props.theme.primary};
    }
  }
`;

const StyledMenuIconSvg = styled(MenuSvgIcon)`
  flex-shrink: 0;

  width: ${props => props.$isDragging ? '12px' : '10px'};
  height: 18px;

  cursor: grab;
  touch-action: none;

  opacity: ${props => props.$isVisible ? 1 : 0};
  transition: opacity 0.3s ease-in-out;

  & rect {
    fill: ${props => props.$isDragging ? props.theme.primary : props.theme.line};
    transition: fill 0.3s ease-in-out;
  }

  @media (hover: hover) {
    &:hover {
      width: 12px;
      height: 18px;
    }
    &:hover rect {
      fill: ${props => props.theme.primary};
    }
  }

  &:active {
    cursor: grabbing;
  }
`;

const StyledCopyIcon = styled(CopyIcon)`
  width: 20px;
  height: 20px;

  & path {
    fill: ${props => props.theme.line};
    transition: fill 0.3s ease-in-out;
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
    &:hover path {
      fill: ${props => props.theme.primary};
    }
  }
`;
